export const LINKEDIN_URL = 'https://www.linkedin.com/in/';
export const SLACK_BASE_URL = 'https://slack.com/oauth/v2/authorize';
export const LINKEDIN_CONNECT = 'https://www.linkedin.com/psettings/member-data';
export const LINKEDIN_SHARE_URL = 'https://www.linkedin.com/sharing/share-offsite/?url=';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet';
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?';
export const WHATSAPP_SHARE_URL = 'https://api.whatsapp.com/send?';
export const LINKEDIN_COMPANY_URL = 'https://linkedin.com/company/';

export const DEFAULT_USER_AVATAR_URL = 'https://boon-public-assests.s3.amazonaws.com/default_user_profile_img.png';

export const COUNTER_START_VALUE = 1440; // 24 hours in minutes

export const FORM_CONSTANTS = {
  MIN_LENGTH: 1,
  MAX_LENGTH: 100,
  YEAR_STRING_LENGTH: 4,
};

export const FORM_MESSAGES = {
  TOO_SHORT: 'formMessages.tooShort',
  TOO_LONG: 'formMessages.tooLong',
};

export const CONTACT_SOURCES = [
  { id: 1, label: 'contactSources.meta', value: 'meta' },
  { id: 2, label: 'contactSources.twitter', value: 'twitter' },
  { id: 3, label: 'contactSources.csvImport', value: 'csv_import' },
  { id: 4, label: 'contactSources.google', value: 'google_people' },
  { id: 5, label: 'contactSources.outlook', value: 'outlook' },
  { id: 6, label: 'contactSources.linkedin', value: 'linkedin' },
  { id: 7, label: 'contactSources.manual', value: 'manual' },
  { id: 8, label: 'contactSources.vcfImport', value: 'vcf_import' },
];

export const SORTBY_OPTIONS = [
  { id: 1, label: 'sortByOptions.ascending', value: 'ascending' },
  { id: 2, label: 'sortByOptions.descending', value: 'descending' },
  { id: 3, label: 'sortByOptions.recentlyAdded', value: 'recent' },
  { id: 4, label: 'sortByOptions.recommended', value: 'recommended' },
];

export const MIN_PASSWORD_LENGTH = 8;

export const CONTACT_EMAIL_TYPES = [
  { value: 'mobile', label: 'Mobile', labelKey: 'contactTypes.mobile' },
  { value: 'home', label: 'Home', labelKey: 'contactTypes.home' },
  { value: 'main', label: 'Main', labelKey: 'contactTypes.main' },
  { value: 'work', label: 'Work', labelKey: 'contactTypes.work' },
  { value: 'other', label: 'Other', labelKey: 'contactTypes.other' },
];

export const CONTACT_PHONE_TYPES = [
  { value: 'work', label: 'Work', labelKey: 'contactTypes.work' },
  { value: 'home', label: 'Home', labelKey: 'contactTypes.home' },
  { value: 'other', label: 'Other', labelKey: 'contactTypes.other' },
];

export const LINKEDIN_REGEX = /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com/;
export const WEBSITE_REGEX =
  /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$/gm;

export const USER_PROFILE_REGEX = /^[a-zA-Z0-9]{3,100}$/;

export const JOB_TYPES = {
  DEPARTMENT: 'department',
  JOB: 'job',
  ALL: 'all',
};

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export const ALLOWED_FORMAT = 'image/jpeg image.png image/png';
export const imageTypes = {
  user_avatar: 0,
  logo_image: 1,
  cover_picture_image: 2,
};

export const JOBS_SORTBY_OPTIONS = [
  { id: 1, label: 'jobsSortByOptions.mostRecent', value: 'jobs_created_at_desc' },
  { id: 2, label: 'jobsSortByOptions.oldest', value: 'jobs_created_at_asc' },
  { id: 3, label: 'jobsSortByOptions.nearestFirst', value: 'nearest_to_farthest' },
  // { id: 3, label: 'Highest Reward to Lowest Reward', value: 'highest_reward' }, TODO::implemetation is left
  // { id: 4, label: 'Lowest Reward to Highest Reward', value: 'lowest_reward' },
];

export const IMPORTED_FROM = {
  DAYFORCE: 'DayForce',
};

export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  CAD: 'C$',
  AUD: 'A$',
  PHP: '₱',
};

export const WORK_PLACE_TYPE_KEYS = {
  Hybrid: 'hybrid',
  'On-site': 'onSite',
  Remote: 'remote',
};

export const REMOTE_WORK_TYPE_KEYS = {
  Urgent: 'urgent',
  Normal: 'normal',
};

export const EXPERIENCE_LEVEL_KEYS = {
  'Trainee - Junior level': 'traineeJuniorLevel',
  Trainee: 'trainee',
  Associate: 'associate',
  Director: 'director',
  Executive: 'executive',
  'Not Applicable': 'notApplicable',
  'Entry & Junior Level': 'entryJuniorLevel',
  'Mid-Senior Level': 'midSeniorLevel',
  'Mid-Senior level': 'midSeniorLevel',
  Intern: 'intern',
  'Senior level': 'seniorLevel',
  'Entry level': 'entryLevel',
  None: 'none',
  'As per job description': 'asPerJobDescription',
};

export const REQUIRED_EDUCATION_KEYS = {
  'High School Diploma/GED': 'highSchoolDiplomaGed',
  "Associate's Degree": 'associatesDegree',
  "Bachelor's Degree": 'bachelorsDegree',
  "Master's Degree": 'mastersDegree',
  "Master's of Business Administration": 'mastersOfBusinessAdministration',
  PHD: 'phd',
  None: 'none',
  'As per opening description': 'asPerOpeningDescription',
};

export const OPPORTUNITY_TYPE_KEYS = {
  'Full-Time': 'fullTime',
  'Part-Time': 'partTime',
  Contract: 'contract',
  Volunteer: 'volunteer',
  Internship: 'internship',
  Temporary: 'temporary',
  Cofounder: 'cofounder',
};

export { INDUSTRY_KEYS } from './industryKeys.js';
export { SKILLS_KEYS } from './skillKeys.js';
